import { defineMessages } from 'react-intl';

export default defineMessages({
    averageMiles: {
        id: 'qnb.spm.vehicleMileage.averageMiles',
        defaultMessage: 'This is an average of {mileage} miles per week',
    },
    vehicleMileageLabel: {
        id: 'qnb.spm.vehicleMileage.vehicleMileageLabel',
        defaultMessage: 'How many miles is the {vehicle} driven per year?'
    },
    vehicleMileageSecondaryLabel: {
        id: 'qnb.spm.vehicleMileage.vehicleMileageSecondaryLabel',
        defaultMessage: 'This should include the total miles covered by all drivers.'
    }
});
